import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { WorkspacesEffects } from "./state/workspaces.effects";
import { membersFeatureKey, membersReducer } from "./state/members.reducer";
import {
  workspacesFeatureKey,
  workspacesReducer,
} from "./state/workspaces.reducer";
import { WorkspaceInterceptor } from "./workspace.interceptor";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(workspacesFeatureKey, workspacesReducer),
    StoreModule.forFeature(membersFeatureKey, membersReducer),
    EffectsModule.forFeature([WorkspacesEffects]),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WorkspaceInterceptor,
      multi: true,
    },
  ],
})
export class WorkspaceCoreModule {}
